import {makeObservable, observable} from 'mobx';
import BlockObject from './BlockObject';

export default class SharedFilesBlockObject extends BlockObject implements ISharedFilesBlockObj {
    fileBlockType: "normalizedFile" | "normalizedFolder" | "onedrive" | "linkToExternalItem" | "file";
    gFileId?: string;
    file?: {
        embeddedViewLink?: string,
        icon: string,
        type: string,
        viewerType: string,
        viewLink: string,
    };
    fileType: "audio" | "image" | "googledocs" | "video" | null;
    fileOrFolder?: {
        icon: string,
        viewLink: string,
        type: string,
    };
    folder?: {
        files: any,
        icon: string,
        title: string,
        type: string,
        viewLink: string,
    };
    url?: string;

    constructor(blockType: OrganizationType, initialBlockObj: ISharedFilesBlockObj | undefined) {
        super(blockType, initialBlockObj);
        this.setAttributes(initialBlockObj);
        makeObservable(this, {
            // fileBlockType: observable,
            // gFileId: observable,
            // file: observable,
            // fileType: observable,
            // fileOrFolder: observable,
            // folder: observable,
            url: observable,
        });
    }

    contentSourceToSettings(contentSource) {
        return {
            url: contentSource.source_url || '',
            source_id: contentSource.id || '',
        }
    }

    contentItemToSettings(contentItem) {
        return {
            url: contentItem.third_party_url || '',
        }
    }

    settingsToContentSource(blockObj, settings, language: string) {
        let contentSource = {};
        if (settings.url !== '' && settings.title !== '') {
            contentSource = {
                source_url: settings.url,
                organization: blockObj.id,
                language,
            }
            // @ts-ignore
            if (settings?.source_id !== '') contentSource.id = settings.source_id;
        }
        return contentSource;
    }

    settingsObjectToSettings(settingsObj: IBlockSettingsObject) {
        return {
            url: settingsObj.url,
            source_id: settingsObj.source_id,
        }
    }


}
